<template>
<div class="page upLoadArt">
    <van-row>
        <van-uploader :after-read="afterRead">
            <van-button type="primary">选择图片</van-button>
        </van-uploader>
        <van-row id="myimg">

        </van-row>
    </van-row>
    <template v-for="(item,index) in artList">
        <van-row :key="'artList'+index" style="margin-bottom: 50px;">
            <van-col span="2">{{index+1}}</van-col>
            <van-col span="8">
                <van-image width="100%" :src="item.Folder+item.FileName" />
            </van-col>
            <van-col span="14" style="padding-left: 10px;text-align: left;">
                <van-row>
                    <van-col span="8" style="font-weight: bolder;">名称：</van-col>
                    <van-col span="16">{{item.WorkName}}</van-col>
                </van-row>
                <van-row>
                    <van-col span="8" style="font-weight: bolder;">拍卖公司：</van-col>
                    <van-col span="16">{{item.OrganName}}</van-col>
                </van-row>
                <van-row>
                    <van-col span="8" style="font-weight: bolder;">拍卖专场：</van-col>
                    <van-col span="16">{{item.SpecialName}}</van-col>
                </van-row>
                <van-row>
                    <van-col span="8" style="font-weight: bolder;">拍卖会：</van-col>
                    <van-col span="16">{{item.SessionName}}</van-col>
                </van-row>
                <van-row>
                    <van-col span="8" style="font-weight: bolder;">拍卖日期：</van-col>
                    <van-col span="16">{{item.Date}}</van-col>
                </van-row>
                <van-row>
                    <van-col span="8" style="font-weight: bolder;">估价：</van-col>
                    <van-col span="16">{{showPrice(item)}}</van-col>
                </van-row>
                <van-row>
                    <van-col span="8" style="font-weight: bolder;">成交价：</van-col>
                    <van-col span="16">{{item.CurrencyPrice/100}}{{item.CurrencyType}}</van-col>
                </van-row>
                <van-row>
                    <van-col span="8" style="font-weight: bolder;">相似值：</van-col>
                    <van-col span="16">{{searchList[index].distance}}</van-col>
                </van-row>
            </van-col>
        </van-row>
    </template>

</div>
</template>

<script>
import axios from 'axios';
import {
    mapActions,
    mapGetters
} from "vuex";
export default {
    data() {
        return {
            artList: [],
            searchList: []
        };
    },
    watch: {

    },
    asyncData({
        store
    }) {
        // console.log(store, 33333);
        let dataJSON = {
            artcode: '',
            passport: 'artron@2022-123456',
        };
        return store.dispatch("pageGetMult/pgGetMult", [dataJSON, () => {}]);
    },
    created() {

    },
    mounted() {

    },
    computed: {
        ...mapGetters({
            getIsLoadIng: "pagePreview/getIsLoadIng",
            getData: "pagePreview/getData",
        }),
    },
    methods: {
        ...mapActions({
            pageGetMult: "pageGetMult/pgGetMult",

        }),
        showPrice(item) {
            switch (item.EvaluationType) {
                case 1:
                    return "无底价"
                case 2:
                    return "咨询价"
                case 3:
                    return "估价待定"
                default:
                    if (item.OriginalEvaluation == 0 && item.LastEvaluation == 0) {
                        return "--"
                    } else if (item.OriginalEvaluation == item.LastEvaluation) {
                        return item.OriginalEvaluation / 100 + item.CurrencyType
                    } else {
                        return item.OriginalEvaluation / 100 + '-' + item.LastEvaluation / 100 + item.CurrencyType
                    }
            }
        },
        filteData() {

            // console.log(this.$store.state["pageGetMult"]["data"])
            let dataList = this.$store.state["pageGetMult"]["data"].data.list
            this.artList = [];
            for (let i in this.searchList) {
                for (let k in dataList) {
                    if (this.searchList[i].artcode == dataList[k].ArtCode) {
                        this.artList.push(dataList[k])
                    }

                }

            }

        },
        afterRead(file) {
            let codeList = []
            // console.log(file)
            var img = new Image()
            let dom = document.getElementById("myimg")
            dom.innerHTML = ""
            dom.appendChild(img);
            dom.classList.add("imgBox")
            var fileRead = new FileReader()
            fileRead.onload = function () {
                img.src = fileRead.result
                //利用base64回显图片
                // console.log(fileRead.result)
            }
            fileRead.readAsDataURL(file.file)

            let fd = new FormData()
            fd.append("Table", 'picture')
            fd.append("Topk", '10')
            fd.append("Image", file.file)
            axios.post("https://pic-search.artron.net/img/search", fd, {
                headers: {
                    "Content-Type": "application/x-www-form-urlencoded"
                }
            }).then(response => {
                if (response.status == 200) {
                    this.searchList = response.data[1]
                    for (let i in this.searchList) {
                        codeList.push(this.searchList[i].artcode)
                    }
                    if (!this.getIsLoadIng) {
                        this.pageGetMult([{
                            artcode: codeList.join(','),
                            passport: 'artron@2022-123456'
                        }, () => {

                            this.filteData();
                        }])
                    } else {

                        this.filteData();
                        // console.log("服务端调用",this.param);

                    }
                    // axios.get("https://api.artron.net/v1/auction/getMult?artcode=" + codeList.join(',') + "&passport=artron@2022-123456").then(res => {
                    //         if (res.data.code == 0) {
                    //             this.artList = res.data.data.list

                    //         }
                    //         console.log(res);
                    //     });

                }
                // console.log(response);
            });

        }

    },
    components: {

    },
};
</script>

<style lang="scss">
.upLoadArt {
    font-size: 0.6rem;

    img {
        max-width: 100%;
        border: none;
        vertical-align: middle;
    }

}
</style>

<style lang="scss" scoped>
// 搜索头部和tab页面
#myimg {

    width: 350px;
    margin: 50px auto;

}

.upLoadArt {
    padding-top: 20px;
    text-align: center;

}
</style>
